import { z } from "zod";

export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 100;

export const paginationQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
  cursor: z.string().min(1).max(512).optional(),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;
/** Query params as sent by clients (the schema coerces strings on the server). */
export interface PaginationQueryInput {
  limit?: number | undefined;
  cursor?: string | undefined;
}

export interface Paginated<T> {
  items: T[];
  nextCursor: string | null;
}

export function paginatedSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
}
